/** Router and error-boundary callbacks hand us `unknown`; components expect an `Error`. */
export function toError(error: unknown): Error {
  return error instanceof Error
    ? error
    : new Error(typeof error === "string" ? error : "Unknown error");
}
